import { render, staticRenderFns } from "./SmppConnection.vue?vue&type=template&id=167975a6&"
import script from "./SmppConnection.vue?vue&type=script&lang=ts&"
export * from "./SmppConnection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports